import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0646d7d1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0646d7d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646d7d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0646d7d1')) {
      api.createRecord('0646d7d1', component.options)
    } else {
      api.reload('0646d7d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0646d7d1&scoped=true", function () {
      api.rerender('0646d7d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/Timeliness/index.vue"
export default component.exports